import React from 'react';
import Grid from '@mui/material/Grid';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material'
import { NavLink } from "react-router-dom";
import img1 from '../../assets/images/aplicaciones-web.webp';
import img4 from '../../assets/images/frontend.jpg'
import img5 from '../../assets/images/backend.jpg'
import img6 from '../../assets/images/pwa1.png'
import img7 from '../../assets/images/pwa2.png'
import img8 from '../../assets/images/pwa3.png'
import transparent from '../../assets/images/transparent.png'

const App=()=>{

  return  <>
            <Grid container justifyContent="center"  spacing={2} sx={{mb:0}} className="bg-white pwa">
              <Grid item xs={12} md={6}  sx={{ mt: {
                                              xs:10,
                                              md:14
                                            },
                                      }}

                >
                <Typography component="h2" className="title-banner text-center">
                  Desarrollo de <b>Aplicaciones Web</b>
                </Typography>
                <Typography component="p" className="text-center p-2">
                  Construimos aplicaciones web de fácil escalabilidad con tecnología como <b>React Js</b>  y <b>Laravel</b>.
                </Typography>
                <Grid className="text-center">
                  <Button  component={NavLink} variant="contained" className={"mt-2"} to="/contact/buenos-dias,-podrían-cotizar-mi-propia-pwa">
                    Quiero cotizar mi PWA
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}  sx={{ mt: {
                                              xs:10,
                                              md:14
                                            },
                                      }} >
                <img src={img1} alt="" className="img-fluid"/>
              </Grid>
              <Grid item xs={12}>
                <Grid className="separator">
                  <img src={transparent} alt={"programandoweb"} className="img-fluid"/>
                </Grid>
              </Grid>
              <Grid item xs={12} className="content-primary">
                <Typography component="h4" className="text-center text-white h4 mb-2 uppercase">
                  ¿Cómo hacemos realidad el desarrollo de <b>aplicaciones web</b>  para tu empresa?
                </Typography>
                <Grid></Grid>
                <Grid container justifyContent="center"  spacing={2} sx={{mb:0}}>
                  <Grid item xs={12} md={3} className="text-center p-2">
                    <Typography component="h1" className="text-center text-white mb-2 uppercase roboto">
                      Desarrollo web <b>Front-End</b>
                    </Typography>
                    <CardMedia
                      component="img"
                      image={img4}
                      alt="programandoweb"
                      title="Aplicacione en React JS"
                    />
                    <Typography component="h4" className="text-center text-white h5 mb-2">
                      Trabajamos en el desarrollo de la interfaz web y en la experiencia de usuario de tu aplicación. Trabajamos en <b>React.js</b> y <b>Laravel</b>.
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={1}>
                  </Grid>

                  <Grid item xs={12} md={3} className="text-center p-2">
                    <Typography component="h1" className="text-center text-white mb-2 uppercase roboto">
                      Desarrollo web <b>Back-End</b>
                    </Typography>
                    <CardMedia
                      component="img"
                      image={img5}
                      alt="programandoweb"
                      title="Aplicacione en React JS"
                    />
                    <Typography component="h4" className="text-center text-white h5 mb-2">
                      Nos encargamos de la funcionalidad y la infraestructura de tu aplicación. Trabajamos en Serverless con <b>PHP</b>, <b>Python</b> y <b>Node.js</b>.
                    </Typography>
                  </Grid>

                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid className="separator2">
                  <img src={transparent} alt={"programandoweb"} className="img-fluid"/>
                </Grid>
              </Grid>




              <Grid item xs={12}>
                <Typography component="h4" className="text-center h4 mb-2 uppercase">
                  ¿Qué tipos de Aplicaciones Web <b>podemos  construir</b> para tu empresa?
                </Typography>
              </Grid>



              <Grid container justifyContent="center"  spacing={0} sx={{mb:0}}>


                <Grid item xs={12} md={2} className="text-center p-2">
                  <CardMedia
                    component="img"
                    image={img6}
                    alt="programandoweb"
                    title="PWA"
                  />
                  <Typography component="h4" className="text-center  h5 mb-2">
                    Progressive Web Application - PWA
                  </Typography>
                </Grid>

                <Grid item xs={12} md={1} className="text-center p-2">
                </Grid>


                <Grid item xs={12} md={2} className="text-center p-2">
                  <CardMedia
                    component="img"
                    image={img7}
                    alt="programandoweb"
                    title="Aplicacione Web"
                  />
                  <Typography component="h4" className="text-center  h5 mb-2">
                    Aplicaciones Web
                  </Typography>
                </Grid>

                <Grid item xs={12} md={1} className="text-center p-2">
                </Grid>


                <Grid item xs={12} md={2} className="text-center p-2">
                  <CardMedia
                    component="img"
                    image={img8}
                    alt="programandoweb"
                    title="Ecommerce"
                  />
                  <Typography component="h4" className="text-center  h5 mb-2">
                    Ecommerce
                  </Typography>
                </Grid>

              </Grid>



            </Grid>
          </>
}
export default App;
